import { api } from '@/api/api'
import { rotasApi } from '@/configurações/rotasApi'
import { useQuery } from '@tanstack/react-query'

export const useRegulamentoGet = () => {
  const { data } = useQuery({
    queryKey: ['regulamento'],
    queryFn: async () => await endPoint(),
  })

  return { data }
}

async function endPoint(): Promise<string> {
  const result = await api().get(rotasApi.regulamentoBuscar)
  return result.data.data
}
